"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonFieldValueGetter = void 0;
const safe_field_value_1 = require("../safe-field-value");
const objects_1 = require("../type-checking/objects");
const primitives_1 = require("../type-checking/primitives");
class ButtonFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue, field) => {
            if (!field) {
                return ((0, primitives_1.isStringValue)(fieldValue) ||
                    (0, objects_1.isObjectWithKeysValue)(fieldValue, ["status"], false, true));
            }
            if (field.params.button_action === "open_url") {
                return (0, primitives_1.isStringValue)(fieldValue);
            }
            if (field.params.button_action === "execute_automation") {
                return (0, objects_1.isObjectWithKeysValue)(fieldValue, ["status"], false, true);
            }
            return false;
        };
        this.getEmptyValue = () => null;
    }
}
exports.ButtonFieldValueGetter = ButtonFieldValueGetter;
